import axios from 'axios'
let urlBase = 'https://api.todoscomemos.com'
if (process.env.NODE_ENV === 'production') {
  urlBase = 'https://api.todoscomemos.com'
} else {
  urlBase = 'https://api.todoscomemos.com'
}

const configService = axios.create({
  baseURL: urlBase,
  headers: {
    'Content-Type': 'application/json',
    'Access-Control-Allow-Origin': '*',
    'accept': 'application/vnd.todoscomemos.v3+json'
  }
})

export {
  configService
}
